// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"t6-z","dimensionLabel":"u6-z","styleChooserControlWrapper":"v6-z","styleChooserControl":"w6-z","disabled":"x6-z","giftCard":"y6-z","styleChooserText":"z6-z"};